export default "__VITE_PUBLIC_ASSET__88c775ba__"